import { Location as NgLocation } from "@angular/common";
import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, CanMatchFn, Router } from "@angular/router";
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalService } from "@azure/msal-angular";

// Wrap deprecated guard class format into new guard functions format
// Use their guard functions if Microsoft provide them in the future

export const msalCanActivate: CanActivateFn = (...args) => {
  const instance = _msalGuardFactory();
  return instance.canActivate.call(instance, ...args);
};

export const msalCanActivateChild: CanActivateChildFn = (...args) => {
  const instance = _msalGuardFactory();
  return instance.canActivateChild.call(instance, ...args);
};

export const msalCanMatch: CanMatchFn = () => {
  const instance = _msalGuardFactory();
  return instance.canMatch.call(instance);
};

const _msalGuardFactory = (): MsalGuard =>
  new MsalGuard(
    inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG),
    inject(MsalBroadcastService),
    inject(MsalService),
    inject(NgLocation),
    inject(Router)
  );
